/**
 * Date-extensions locale Tagalog (Philippines) [tl-ph]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tl-ph', {
    monthNames: ['Enero','Pebrero','Marso','Abril','Mayo','Hunyo','Hulyo','Agosto','Setyembre','Oktubre','Nobyembre','Disyembre'],
    monthShortNames: ['Ene','Peb','Mar','Abr','May','Hun','Hul','Ago','Set','Okt','Nob','Dis'],
    dayNames: ['Linggo','Lunes','Martes','Miyerkules','Huwebes','Biyernes','Sabado'],
    dayShortNames: ['Lin','Lun','Mar','Miy','Huw','Biy','Sab']
});
